import {
  app,
} from './initializeApp'

import {
  getAuth,
  signInWithEmailAndPassword as _signInWithEmailAndPassword,
} from 'firebase/auth'

const auth = getAuth(app)

export const signInWithEmailAndPassword = email => password =>
(
  _signInWithEmailAndPassword(auth, email, password)
)